export default (pxValue = 0) => `${pxValue / 16}rem`;
